import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogCreaIroComponent } from 'src/app/page/analisi-materialita/doppia-materialita/dialog/dialog-crea-iro/dialog-crea-iro.component';
import { DoppiaMaterialitaService } from 'src/app/services/doppia-materialita/doppia-materialita.service';
import { UtilityService } from 'src/app/services/utility/utility.service';

@Component({
  selector: 'app-dialog-scelta-campione',
  standalone: false,

  templateUrl: './dialog-scelta-campione.component.html',
  styleUrl: './dialog-scelta-campione.component.scss',
})
export class DialogSceltaCampioneComponent {
  public sceltaCampione = '';
  public obbligatorio = false;

  constructor(
    private readonly cdRef: ChangeDetectorRef,
    private readonly utilityService: UtilityService,
    public readonly dialogRef: MatDialogRef<DialogCreaIroComponent>,
    private readonly doppiaMaterialitaService: DoppiaMaterialitaService,

    @Inject(MAT_DIALOG_DATA)
    public data: {
      idMaterialita: string;
      tipologia: string;
      idCategoria: string;

      sceltaCampione?: string;
      obbligatorio?: boolean;
    },
  ) {}

  ngAfterViewInit(): void {
    this.datiIniziali();
    this.cdRef.detectChanges();
  }

  public datiIniziali() {
    this.sceltaCampione = this.data.sceltaCampione || '';
    this.obbligatorio = !!this.data.obbligatorio;
  }

  public conferma() {
    if (this.obbligatorio && !(this.sceltaCampione ?? '').trim()) {
      this.utilityService.openSnackBar(
        'È obbligatorio inserire la motivazione della scelta del campione.',
        '',
        {
          duration: 4000,
          panelClass: ['red-snackbar'],
        },
      );
      return;
    }

    this.dialogRef.close({ salva: true, sceltaCampione: this.sceltaCampione });
  }

  public chiudi() {
    this.dialogRef.close({ salva: false });
  }
}
